"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createStyles = _interopRequireDefault(require("@material-ui/core/styles/createStyles"));
var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var useStyles = (0, _makeStyles.default)(theme => (0, _createStyles.default)({
  loadingIndicator: {
    marginRight: theme.spacing(2)
  },
  clearField: {
    marginRight: theme.spacing(1),
    // color: theme.palette.custom.grey.main,
    zIndex: 2,
    cursor: 'pointer'
  }
}));
var _default = exports.default = useStyles;